import { useState } from 'react';
import IconHome from '../../../../components/Icon/IconHome';
import DashboardTabComp from '../../../../components/DashboardComponents/DashboardTabComp';
// import ProductionData from '../../Data/DashboardData/UserLevelDBProductionData.json';
import { IconLayersDifference, IconLayoutList } from '@tabler/icons-react';
import QualityManagerDashboardMain from './QualityManagerDashboardMain';
import QMPbiRatings from './QMPbiRatings';

function QMDashboardMain() {
  const [activeTab, setActiveTab] = useState(0); // State to track active tab

  const tabs = [
    {
      label: 'Quality',
      icon: IconHome,
      header: '',
      component: <QualityManagerDashboardMain />,
    //   data: ProductionData,
    },
     {
      label: 'PBI/BQM',
      icon: IconLayoutList,
      header: '',
      component: <QMPbiRatings />,
      data: '',
    },
  ];
  return (
    <>
      {/* <DashboardDropdown /> */}
      <DashboardTabComp
        tabs={tabs}
        activeTab={activeTab} // Pass activeTab to manage which tab is selected
        onTabChange={setActiveTab} // Pass setActiveTab to update activeTab state
        data={tabs[activeTab]?.data} // Pass data of the currently active tab
      />
    </>
  );
}
export default QMDashboardMain;
